import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ValidatorComponent } from '@feature/survey-management/components/validator/validator.component';
import { TranslateModule } from '@ngx-translate/core';
import { ValidatorType } from '@shared/models/enums/validator-type.enum';
import { SingleSelect } from '@shared/models/question-types/single-select';
import { TextMeasurementUtil } from '@shared/utils/text-measurement.util';
import { QuestionBaseComponent } from '../../question-base/question-base.component';
import { SliderComponent } from '../slider/slider.component';
import { SingleSelectRadioButtonComponent } from './single-select-radio-button/single-select-radio-button.component';

@Component({
  selector: 'app-single-select',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    SliderComponent,
    SingleSelectRadioButtonComponent,
    QuestionBaseComponent,
    ValidatorComponent,
  ],
  templateUrl: './single-select.component.html',
  styleUrl: './single-select.component.scss',
})
export class SingleSelectComponent implements AfterViewInit, OnDestroy {
  @Input({ required: true }) question!: SingleSelect;
  @Input({ required: true }) control!: any;
  @Input() otherControl?: any;
  @Input() isFirstQuestion: boolean = false;
  ValidatorType = ValidatorType;

  scaleColumns: number = 1;

  private resizeObserver?: ResizeObserver;

  constructor(
    private el: ElementRef,
    private cdr: ChangeDetectorRef,
  ) {}

  get isScaleMode(): boolean {
    return this.question.presentation === 'HORIZONTAL';
  }

  get quotaErrorAlternativeId(): string | undefined {
    return this.control?.errors?.['QuotaError']?.alternativeId;
  }

  ngAfterViewInit(): void {
    if (!this.isScaleMode) return;

    this.resizeObserver = new ResizeObserver(() => {
      this.updateScaleLayout();
    });
    this.resizeObserver.observe(this.el.nativeElement);
    this.updateScaleLayout();
  }

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
  }

  getMinTileWidth(): number {
    if (!this.question?.alternatives) return 120;
    return TextMeasurementUtil.calculateMinTileWidth(
      this.question.alternatives,
      this.question.id,
    );
  }

  private updateScaleLayout(): void {
    const containerWidth = this.el.nativeElement.clientWidth;
    const count = this.question.alternatives?.length ?? 0;

    const fits = TextMeasurementUtil.fitsInSingleRow(
      this.question.alternatives,
      containerWidth,
    );

    this.scaleColumns = fits ? count : 1;
    this.cdr.detectChanges();
  }
}
